import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function ConfirmationInvoice({
    isOpen,
    onClose,
    id,
    onConfirm
}) {

    // const toggle = () => setModal(!modal);

    return (
        <>

            <Modal isOpen={isOpen} toggle={onClose} centered>
                <ModalBody>
                    <div className='conform_btn_area'>
                        <Link to={`/billings/pdf-view/${id}?type=detailed`} className="main_button text-nowrap">Detailed invoice </Link>
                        <Link to={`/billings/pdf-view/${id}?type=compressed`} className="main_button text-nowrap">Compressed invoice</Link>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {/* <button className="main_button" onClick={onConfirm}>Yes</button> */}
                    <button className="table_delete" onClick={onClose}>Cancel</button>
                </ModalFooter>
            </Modal>


        </>
    );
}

export default ConfirmationInvoice;